var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgc-p bdr-4 p-10"},[_c('h1',{staticClass:"color-w pb-10"},[_vm._v(_vm._s(_vm.echartsName))]),_c('div',{style:({ width: '30rem', height: '20rem', padding: '0 1rem', color: 'ffffff' }),attrs:{"id":"bar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }